import {
  idEnums,
  gendersEnum,
  civilStateEnum,
  vehiclesEnum,
} from '../../../../../assets/helpers/options';
import { faker } from '@faker-js/faker';
import moment from 'moment';

export const preloadPersonalData = (setValue) => {
  const startDate = new Date(1945, 0, 1); // January 1, 2023
  const endDate = new Date(2007, 11, 31); // December 31, 2023

  setValue('documentTypeImage', 'identity');
  setValue('identificationType', idEnums.V);
  setValue('identification', faker.number.int({ min: 500000, max: 35000000 }));
  setValue('email', faker.internet.email().toLowerCase());
  setValue('optionalEmail', faker.internet.email().toLowerCase());
  setValue('firstName', faker.person.firstName());
  setValue('lastName', faker.person.lastName() + ' Prueba');
  setValue('phone', '+584145552233');
  setValue(
    'birthday',
    new Date(faker.date.between({ from: startDate, to: endDate }))
  );
  setValue('gender', faker.helpers.arrayElement(Object.values(gendersEnum)));
  setValue(
    'maritalStatus',
    faker.helpers.arrayElement(Object.values(civilStateEnum))
  );
  setValue('broadcastChannel', '64690d9c492120cea1c15f83');
};

const DEFAULT_PRELOAD_TYPE_ID = '6469397a890fc63241477006';

export const generateRandomPlate = () => {
  const letters = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
  const pickLetter = () =>
    letters[faker.number.int({ min: 0, max: letters.length - 1 })];

  if (faker.datatype.boolean()) {
    return `${pickLetter()}${pickLetter()}${faker.number.int({
      min: 100,
      max: 999,
    })}${pickLetter()}${pickLetter()}`;
  }

  return `${pickLetter()}${pickLetter()}${pickLetter()}${faker.number.int({
    min: 100,
    max: 999,
  })}`;
};

export const resolvePreloadTypeId = (types) => {
  const defaultType = types?.find((type) => type?._id === DEFAULT_PRELOAD_TYPE_ID);
  return defaultType?._id || types?.[0]?._id || DEFAULT_PRELOAD_TYPE_ID;
};

const shouldPreloadRcvFields = (membership, membershipElement) => {
  if (membership?.rcv === 'N/A') return false;
  if (!membershipElement) return true;

  if (membershipElement?.dataTable?.rcv !== undefined) {
    return membershipElement.dataTable.rcv !== 'N/A';
  }

  return Boolean(membershipElement?.rcv);
};

export const preloadVehicleData = (
  setValue,
  membership,
  membershipElement,
  watch,
  typeId = DEFAULT_PRELOAD_TYPE_ID
) => {
  setValue('type', typeId);
  setValue('brand', '6469228923c7f1fa25cd42a3');
  setValue('model', '661db6af736381f9a0b3ef24');
  setValue('color', 'Plateado');
  setValue('state', '64695c7b447d0aa9c65969f7');
  setValue('city', '64695ffba034e218fab88f15');
  setValue('municipality', '64696190993d3f9f2bd142e5');
  setValue('address', 'Terrazas del avila calle 5');
  setValue('addressReference', 'Cerca del farmatodo');
  // setValue('km', faker.number.int({ min: 5000, max: 6000000 }));
  setValue('customerIsOwner', true);

  if (shouldPreloadRcvFields(membership, membershipElement)) {
    setValue('engineSerial', faker.vehicle.vin());
    setValue('bodySerial', faker.vehicle.vin());
    setValue('profession', 'Ganadero');
    setValue('economicActivity', '6654b6fbeaf71d45e27bea7a');
    setValue('seats', 4);
  }
  //  Preload owner Data
  if (watch('customerIsOwner') === false) {
    setValue('ownerFirstName', faker.person.firstName());
    setValue('ownerLastName', faker.person.lastName() + ' Prueba');
    setValue('ownerIdentificationType', idEnums.V);
    setValue(
      'ownerIdentification',
      faker.number.int({ min: 500000, max: 35000000 })
    );
    setValue('ownerState', '64695c7b447d0aa9c65969f7');
    setValue('ownerCity', '64695ffba034e218fab88f15');
    setValue('ownerAddress', 'Terrazas del avila calle 5');
  }

  if (watch('isVehicleDriver') === false) {
    setValue('rcvHolderFirstName', faker.person.firstName());
    setValue('rcvHolderLastName', faker.person.lastName() + ' Prueba');

    setValue('rcvHolderIdentificationType', idEnums.V);
    setValue(
      'rcvHolderIdentification',
      faker.number.int({ min: 500000, max: 35000000 })
    );
    setValue('rcvHolderPhonePrefix', '0414');
    setValue('rcvHolderPhoneNumber', '5552233');
    setValue('rcvHolderState', '64695c7b447d0aa9c65969f7');
    setValue('rcvHolderCity', '64695ffba034e218fab88f15');
    setValue('rcvHolderAddress', 'Terrazas del avila calle 5');
  }
};

export const handleTestImageUpload = async (onDrop, fileImage, imageName) => {
  console.log('fileImage:', fileImage);
  try {
    const response = await fetch(fileImage);
    console.log('response:', response);
    const blob = await response.blob();
    console.log('blob:', blob);
    const file = new File([blob], imageName, { type: 'image/jpeg' }); // Adjust type if needed
    console.log('file:', file);
    onDrop([file]);
  } catch (error) {
    console.error('Error uploading test image:', error);
  }
};

const DEFAULT_PRELOAD_AUTO_CLASS_ID = '64691e105254c7956edd4db2';

export const preloadMembershipData = (setValue, vehicleClassesOptions = []) => {
  setValue('year', faker.number.int({ min: 1970, max: 2025 }));

  const autoClass = vehicleClassesOptions.find(
    (vehicleClass) => vehicleClass?.name === vehiclesEnum.AUTOMOVIL
  );
  const motoClass = vehicleClassesOptions.find(
    (vehicleClass) => vehicleClass?.name === vehiclesEnum.MOTO
  );
  const classOptions = [autoClass, motoClass].filter(Boolean);
  const selectedClass = classOptions.length
    ? faker.helpers.arrayElement(classOptions)
    : { _id: DEFAULT_PRELOAD_AUTO_CLASS_ID };

  setValue('class', selectedClass._id);
  setValue('armorType', '');
};
